import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';
import Slider from 'react-slick';

import StudioActivityContent 	from './_StudioActivityContent.jsx';
import StudioLandingFeature 	from './_StudioLandingFeature.jsx';
import {StudioEvents}					from './_StudioEvents.jsx';
import StudioMoreInformation from './_StudioMoreInformation.jsx';


import MocCard 			from '../common/_MocCard.jsx';
import {StudioLogo} from '../common/_Icons';
import HiddenScroll from '../common/_HiddenScroll';
import HeroSlider 	from '../common/_HeroSlider.jsx';

export default class StudioLanding extends BLComponent {
	constructor (props) {
		super(props);

		this.state = {
			content: this.props.content ? this.props.content : blapp.models.get('config'),
			activeSlide: 0
		};

		this.slickSettings = {
			dots: false,
			arrows: false,
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 4,
			adaptiveHeight: true,
			beforeChange: (current, next) => this.setState({activeSlide: next}),
			responsive: [
				{
					breakpoint: 1048,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: false,
					}
				}
			]
		}
	}

	render() {
		return (
			<React.Fragment>
				{this.renderHeader()}
				<div className="main main--white">
					<div className="main__content">
						{this.renderAnnouncements()}
						{this.renderActivity()}
						{this.renderFeatures()}
						{this.renderDownload()}
						{this.renderStaffPicks()}
						{this.renderMarketingBanner()}
						{this.renderHelpTopics()}
						{this.renderMoreInfo()}
					</div>
				</div>
			</React.Fragment>
		);
	}	

	renderHeader() {
		return (
			<section className="studio-landing__header">
				<StudioLogo classes="studio-landing__header-logo"/>
				<h1 className="studio-landing__header-title">Brick building software, powered by the LEGO Group.</h1>
				<a className="btn btn--yellow studio-landing__header-cta" href={blapp.url2.getStudioDownloadUrl()}>Download today<i className="fas fa-long-arrow-right l-margin-left text--small-title"/></a>
			</section>
		);
	}

	renderAnnouncements() {
		const {announcements} = this.state.content;

		const announcementItems = announcements.filter(item => item.bVisible).map((item, key) => {
			return (
				<article key={item.idAnnouncement} className={`studio-announcement ${item.strStyle == 'NEW' ? 'studio-announcement--new' : 'studio-announcement--just-released'}`}>
					<div className="studio-announcement__internal">
						<div className="studio-announcement__tag">{item.strStyle == 'NEW' ? 'New' : 'Just Released'}</div>
						<div className="studio-announcement__content" dangerouslySetInnerHTML={{__html: item.strContent}}/>
					</div>
				</article>
			);
		})

		if(announcementItems.length) {
			return (
				<section className="studio-landing__content-section">
					<div className="studio-landing__announcements">
						{announcementItems}
					</div>
				</section>
			);
		}else{
			return false;
		}
	}

	renderActivity() {
		const activity = this.state.content.lastActivity;

		console.log(activity);

		if(activity) {
			return (
				<section className="studio-landing__content-section">
					<header className="l-margin-bottom--l">
						<h2 className="text--xxl-title text--bold text--tight">Latest Activity</h2>
						<h3 className="text--title text-color--darkest72">Participate in activities and flex your building skills</h3>
					</header>
					<StudioActivityContent activity={activity} slug={activity.strEventTag} studioLanding/>
				</section>
			);
		}else{
			return false;
		}
	}

	renderFeatures() {
		const {features} = this.state.content;

		const featureItems = features.filter(item => item.bVisible).map(feature => <StudioLandingFeature feature={feature}/>);

		if(featureItems.length) {
			return (
				<section className="studio-landing__content-section">
					<header className="l-margin-bottom--l">
						<h2 className="text--xxl-title text--bold text--tight">Highlighted Features</h2>
					</header>
					<div className="studio-landing__features">
						{featureItems}
					</div>
				</section>
			);
		}else{
			return false;
		}
	}

	renderDownload() {
		const isMobile = blapp.md.tablet() || blapp.md.mobile() || blapp.md.phone();

		return (
			<section className="studio-landing__content-section studio-landing__content-section--download text--center">
				<article className="studio-landing__download">
					<div className="studio-landing__download-image">
						<img src={`//${blapp.config.getHost("static2")}/img/studio-landing-new/download-bird.png`} alt="'Brid' designed by fmate01614"/>
					</div>
					<div className="studio-landing__download-details">
						<h2 className="studio-landing__download-title">Unlock your creativity</h2>
						{isMobile ? 
							<p className="studio-landing__download-mobile">Download Studio on your desktop today!</p> 
						:
							<a href={blapp.url2.getStudioDownloadUrl()} className="studio-landing__download-cta">Download Studio 2.0 today!<i className="fas fa-long-arrow-right l-margin-left"/></a>
						}
					</div>
				</article>
			</section>
		);
	}

	renderStaffPicks() {
		const staffPicks = this.state.content.staffPicked;

		const mocs = 	staffPicks.filter(model => model && model.dmMainImage != null).map((model) => {
			if(model) {
				return <MocCard key={model && model.idModel} data={MocCard.getDataFromModel(model)} awards={this.getAwards(model)}/>
			}
		});

		return (
			<section className="studio-landing__content-section">
				<header className="l-margin-bottom--l l-flex l-split l-end">
					<div className="l-margin-right">
						<h2 className="text--xxl-title text--bold text--tight">This week's staff picks</h2>
					</div>
					<a className="l-nowrap" href={blapp.url2.getStudioGalleryUrl()}>See all staff picks</a>
				</header>
				<div className="studio-landing__staff-picks studio-landing__staff-picks--large">
					<Slider className="studio-landing__staff-picks-slider" ref={mocSlider => this.mocSlider = mocSlider} {...this.slickSettings}>
						{mocs}
					</Slider>
					<div className="l-flex l-center l-end--justify l-margin-top--xl">
						<ul className="slick-dots l-margin-top--null l-margin-right studio-landing__staff-picks-pagination studio-landing__staff-picks-pagination--large">
							<li className={this.state.activeSlide == 0 ? 'slick-active' : ''}>
								<button onClick={() => this.changeSlide(0)}>0</button>
							</li>
							<li className={this.state.activeSlide == 4 ? 'slick-active' : ''}>
								<button onClick={() => this.changeSlide(4)}>4</button>
							</li>
							<li className={this.state.activeSlide == 8 ? 'slick-active' : ''}>
								<button onClick={() => this.changeSlide(8)}>8</button>
							</li>
						</ul>
						<ul className="slick-dots l-margin-top--null l-margin-right studio-landing__staff-picks-pagination studio-landing__staff-picks-pagination--small">
							<li className={this.state.activeSlide == 0 ? 'slick-active' : ''}>
								<button onClick={() => this.changeSlide(0)}>0</button>
							</li>
							<li className={this.state.activeSlide == 3 ? 'slick-active' : ''}>
								<button onClick={() => this.changeSlide(3)}>3</button>
							</li>
							<li className={this.state.activeSlide == 6 ? 'slick-active' : ''}>
								<button onClick={() => this.changeSlide(6)}>6</button>
							</li>
							<li className={this.state.activeSlide == 9 ? 'slick-active' : ''}>
								<button onClick={() => this.changeSlide(9)}>9</button>
							</li>
						</ul>
						<div className="l-flex">
							<button className="paginate-arrow-btn" disabled={this.state.activeSlide == 0} onClick={() => this.prevSlide()}>
								<i className="fas fa-chevron-left"/>
							</button>
							<button className="paginate-arrow-btn" disabled={this.state.activeSlide == 9} onClick={() => this.nextSlide()}>
								<i className="fas fa-chevron-right"/>
							</button>
						</div>
					</div>
				</div>
				<HiddenScroll classes="studio-landing__staff-picks studio-landing__staff-picks--small">
					{mocs}
				</HiddenScroll>
			</section>
		);
	}

	renderPagination(amount) {
		let pagination = [];

		for(let i = 0; i <= amount; i++) {
				pagination.push(
					<li key={i} className={this.state.activeSlide == i ? 'slick-active' : ''}>
						<button onClick={() => this.changeSlide(i)}>{i}</button>
					</li>
				);
		}

		return pagination;
	}

	nextSlide() {
		this.mocSlider.slickNext();
	}
	prevSlide() {
		this.mocSlider.slickPrev();
	}

	changeSlide(slide) {
		this.setState({activeSlide: slide});

		this.mocSlider.slickGoTo(slide);
	}

	getAwards(model) {
		let awards = []

		if(model.nTypeBadge > 0) {
			awards.push(model.nTypeBadge);
		}

		if(model.listEventBadges) {
			awards.push(StudioEvents(model.listEventBadges[0]));
		}
			
		return awards;
	}

	renderMarketingBanner() {
		const {banners} = this.state.content;

		if(banners.length) {
			return (
				<section className="studio-landing__content-section">
					<HeroSlider items={banners}/>
				</section>
			);
		}else{
			return null;
		}
	}

	renderHelpTopics() {
		return (
			<section className="studio-landing__content-section">
				<header className="l-margin-bottom--l">
					<h2 className="text--title text--bold text--tight">Studio Help topics</h2>
					{/*<h3 className="text--small-title text-color--darkest72">Find articles about everything from getting started to buying your design</h3>*/}
				</header>

				<div className="studio-landing__help-topics">
					<article className="card studio-landing-help-card">
						<a href="https://studiohelp.bricklink.com/hc/en-us/categories/5404814688023-Getting-Started" className="card__internal studio-landing-help-card__internal studio-landing-help-card__internal--started">
							<i className="studio-landing-help-card__icon fa-fw fal fa-lightbulb-on"/>
							<h2 className="studio-landing-help-card__title">Getting Started</h2>
						</a>
					</article>
					<article className="card studio-landing-help-card">
						<a href="https://studiohelp.bricklink.com/hc/en-us/categories/5406349314199-Build" className="card__internal studio-landing-help-card__internal studio-landing-help-card__internal--build">
							{this.renderBuildIcon()}
							<h2 className="studio-landing-help-card__title">Build</h2>
						</a>
					</article>
					<article className="card studio-landing-help-card">
						<a href="https://studiohelp.bricklink.com/hc/en-us/categories/5704971941015-Render" className="card__internal studio-landing-help-card__internal studio-landing-help-card__internal--render">
							<i className="studio-landing-help-card__icon fa-fw fal fa-photo-film"/>
							<h2 className="studio-landing-help-card__title">Render</h2>
						</a>
					</article>
					<article className="card studio-landing-help-card">
						<a href="https://studiohelp.bricklink.com/hc/en-us/categories/360002182253-Instruction-Maker" className="card__internal studio-landing-help-card__internal studio-landing-help-card__internal--instruction">
							<i className="studio-landing-help-card__icon fa-fw fal fa-book-open"/>
							<h2 className="studio-landing-help-card__title">Instruction Maker</h2>
						</a>
					</article>
					<article className="card studio-landing-help-card">
						<a href="https://studiohelp.bricklink.com/hc/en-us/categories/5705059750167-Gallery" className="card__internal studio-landing-help-card__internal studio-landing-help-card__internal--gallery">
							<i className="studio-landing-help-card__icon fa-fw fal fa-gallery-thumbnails"/>
							<h2 className="studio-landing-help-card__title">Gallery</h2>
						</a>
					</article>
					<article className="card studio-landing-help-card">
						<a href="https://studiohelp.bricklink.com/hc/en-us/categories/5705467587223-Realizing-designs" className="card__internal studio-landing-help-card__internal studio-landing-help-card__internal--realizing">
							<i className="studio-landing-help-card__icon fa-fw fal fa-store"/>
							<h2 className="studio-landing-help-card__title">Realizing designs</h2>
						</a>
					</article>
					<article className="card studio-landing-help-card">
						<a href="https://studiohelp.bricklink.com/hc/en-us/categories/5872302702359-PartDesigner" className="card__internal studio-landing-help-card__internal studio-landing-help-card__internal--partdesigner">
							<i className="studio-landing-help-card__icon fa-fw fal fa-palette"/>
							<h2 className="studio-landing-help-card__title">PartDesigner</h2>
						</a>
					</article>
				</div>
			</section>
		);
	}

	renderMoreInfo() {
		return (
			<section className="studio-landing__content-section">
				<StudioMoreInformation/>
			</section>
		);
	}

	renderBuildIcon() {
		return (
			<svg
				className="studio-landing-help-card__icon"
				xmlns="http://www.w3.org/2000/svg"
				width="30"
				height="24"
				fill="none"
				viewBox="0 0 30 24"
			>
				<title>A LEGO Brick with a hole in the middle</title>
				<g clipPath="url(#clip0_603_2631)">
					<path
						fill="#0A1E32"
						fillRule="evenodd"
						d="M4.05 1.5c0-.966.783-1.75 1.75-1.75h6c.966 0 1.75.784 1.75 1.75v3a.75.75 0 01-1.5 0v-3a.25.25 0 00-.25-.25h-6a.25.25 0 00-.25.25v3a.75.75 0 11-1.5 0v-3zm-1.75 6v15h25v-15h-25zM1.8 6a1 1 0 00-1 1v16a1 1 0 001 1h26a1 1 0 001-1V7a1 1 0 00-1-1h-26zM17.6-.25a1.75 1.75 0 00-1.75 1.75v3a.75.75 0 001.5 0v-3a.25.25 0 01.25-.25h6a.25.25 0 01.25.25v3a.75.75 0 001.5 0v-3A1.75 1.75 0 0023.6-.25h-6z"
						clipRule="evenodd"
					></path>
					<circle
						cx="14.929"
						cy="15"
						r="5.25"
						stroke="#0A1E32"
						strokeWidth="1.5"
					></circle>
					<circle cx="14.929" cy="15" r="3" stroke="#0A1E32"></circle>
				</g>
				<defs>
					<clipPath id="clip0_603_2631">
						<path fill="#fff" d="M0 0H29.6V24H0z"></path>
					</clipPath>
				</defs>
			</svg>
		);
	}
}

document.addEventListener("DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<StudioLanding blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-studio' )
						);
		blapp.refs.register( "main", elem );
	}
);